module.exports = __webpack_public_path__ + "static/media/energy8.04f8d794.jpeg";